/**
 * CourseCustomFieldService
 * Service for managing course-level custom-field definitions
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for course custom-field definition CRUD operations. Read views are enriched with
 * the resolved shared CustomFieldType (name/color/icon/data-kind).
 */
export class CourseCustomFieldService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CourseCustomFieldService.DEFAULT_SERVICE_PATH,
            basePath: CourseCustomFieldService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** Get all custom-field definitions for a course (enriched views). */
    async byCourse(courseId) {
        const response = await this.byCourseRaw(courseId);
        return response.data ?? [];
    }
    byCourseRaw(courseId) {
        return this.http.get(this.buildUrl(`by-course/${courseId}`));
    }
    /** Get a single custom-field definition (enriched view). */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data)
            throw new Error(`Course custom field ${id} not found`);
        return response.data;
    }
    getViewRaw(id) {
        return this.http.get(this.buildUrl(`${id}`));
    }
}
CourseCustomFieldService.DEFAULT_SERVICE_PATH = 'ac-courses';
CourseCustomFieldService.BASE_PATH = 'api/course-custom-fields';
//# sourceMappingURL=CourseCustomFieldService.js.map